<template>
  <div v-if="$route.name === 'notFound'">
    <RouterView />
  </div>
  <div v-else-if="$route.name == 'main'">
    <GnbArea />
    <RouterView />
    <FooterArea />
  </div>
  <div v-else-if="meta.category && !meta.isLnb">
    <GnbArea />
    <section id="container">
      <TopNavigation />
      <div id="subPage">
        <RouterView />
      </div>
    </section>
    <FooterArea />
  </div>
  <div v-else-if="meta.category && meta.isLnb">
    <GnbArea />
    <section id="container">
      <TopNavigation />
      <div id="subPage">
        <LnbArea />
        <RouterView />
      </div>
    </section>
    <FooterArea />
  </div>
  <div v-else-if="meta.isFullpage">
    <RouterView />
  </div>
  <div v-else>
    <GnbArea />
    <div id="subPage">
      <RouterView />
    </div>
    <FooterArea />
  </div>
  <CheckModal v-if="alertType === 'check'" />
  <WarningModal v-else-if="alertType === 'warning'" />
  <ConfirmModal v-else-if="alertType === 'confirm'" />
  <ReceiptModal v-else-if="alertType === 'receipt'" />
</template>

<script>
import GnbArea from '@/pages/layout/GnbArea.vue';
import LnbArea from '@/pages/layout/LnbArea.vue';
import FooterArea from '@/pages/layout/FooterArea.vue';
import TopNavigation from '@/components/TopNavigation.vue';
import { isArray, isEmpty } from 'lodash';
import CheckModal from '@/components/modal/CheckModal.vue';
import WarningModal from '@/components/modal/WarningModal.vue';
import ConfirmModal from '@/components/modal/ConfirmModal.vue';
import ReceiptModal from '@/components/modal/ReceiptModal.vue';

export default {
  components: {
    GnbArea,
    LnbArea,
    FooterArea,
    TopNavigation,
    CheckModal,
    WarningModal,
    ConfirmModal,
    ReceiptModal,
  },

  computed: {
    alertType() {
      return this.$store.state.modalStore.alertType;
    },

    meta() {
      return this.$route.meta;
    },

    loginDateTime() {
      return this.$store.state.userStore.loginDateTime;
    },

    localStorageKeepMilliseconds() {
      return process.env.VUE_APP_LOCALSTORAGE_KEEP_HOURS * 60 * 60 * 1000;
    },
  },

  watch: {
    async $route(to, from) {
      const isQueryStringEmpty = isEmpty(to.query);

      if (from.path === '/' && isQueryStringEmpty) {
        this.setRefreshed(false);
      } else if (from.path === to.path && isQueryStringEmpty) {
        const childComponents = to.matched;

        if (isArray(childComponents)) {
          await this.$nextTick();
          const instanceComponent = childComponents[0].instances?.default;

          if (instanceComponent?.init) {
            this.setRefreshed(true);
            this.$pushQueryString(null, null);
            instanceComponent.init();
          }
        }
      }
    },
  },

  beforeCreate() {
    window.addEventListener('beforeunload', () => this.setRefreshed(true));
  },

  created() {
    if (
      this.loginDateTime &&
      new Date().getTime() - this.loginDateTime >
        this.localStorageKeepMilliseconds
    ) {
      this.$store.dispatch('logout');
    }
  },

  methods: {
    setRefreshed(status) {
      this.$store.commit('isRefreshed', status);
    },
  },
};
</script>
